import React, { useState } from "react";

const C = {
  bg:      "#F8F6F1",
  surface: "#1C3A28",
  text:    "#F8F6F1",
  muted:   "rgba(248,246,241,0.65)",
  green:   "#9FE1CB",
  terra:   "#C4622D",
};

const stepsFR = [
  { emoji: "🚐", title: "Bienvenue sur CheckVan !", desc: "Votre carnet de bord numérique pour camping-car et van aménagé. Gardez tout en ordre en quelques minutes.", color: "#2D5A3D" },
  { emoji: "✅", title: "Checklist véhicule", desc: "Vérifiez l'état mécanique et les équipements de votre van — cellule, énergie, eau, sécurité. La barre verte indique l'état général.", color: "#9FE1CB" },
  { emoji: "📄", title: "Gérez vos dossiers", desc: "Enregistrez votre assurance, contrôle technique et factures garage. L'app vous rappelle avant les échéances.", color: "#EF9F27" },
  { emoji: "💰", title: "Suivez vos dépenses", desc: "Notez vos pleins, dépenses voyage et camping. L'app calcule votre consommation et le coût de chaque voyage.", color: "#C4622D" },
  { emoji: "🔗", title: "Passeport QR", desc: "Votre van génère automatiquement un passeport d'entretien avec QR code. Partagez-le avec votre garagiste ou lors d'une vente — il contient toutes vos interventions et photos de factures.", color: "#5B8DB8" },
  { emoji: "🚀", title: "C'est parti !", desc: "Commencez par configurer votre van. En moins de 2 minutes votre carnet de bord est prêt !", color: "#2D5A3D" },
];

const stepsEN = [
  { emoji: "🚐", title: "Welcome to CheckVan!", desc: "Your digital logbook for motorhomes and campervans. Keep everything in order in just a few minutes.", color: "#2D5A3D" },
  { emoji: "✅", title: "Vehicle checklist", desc: "Check the mechanical condition and equipment of your van — living area, energy, water, safety. The green bar shows the overall status.", color: "#9FE1CB" },
  { emoji: "📄", title: "Manage your documents", desc: "Store your insurance, MOT and garage invoices. The app reminds you before deadlines.", color: "#EF9F27" },
  { emoji: "💰", title: "Track your expenses", desc: "Log your fill-ups, trip and camping expenses. The app calculates your consumption and the cost of each trip.", color: "#C4622D" },
  { emoji: "🔗", title: "QR Passport", desc: "Your van automatically generates a maintenance passport with a QR code. Share it with your garage or when selling — it includes all your service history and invoice photos.", color: "#5B8DB8" },
  { emoji: "🚀", title: "Let's go!", desc: "Start by setting up your van. Your logbook will be ready in less than 2 minutes!", color: "#2D5A3D" },
];

export default function TutoScreen({ onClose, lang }) {
  const steps = lang === "en" ? stepsEN : stepsFR;
  const [step, setStep] = useState(0);
  const current = steps[step];
  const isLast = step === steps.length - 1;

  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(28,58,40,0.97)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "-apple-system, 'SF Pro Display', sans-serif" }}>
      <div style={{ background: C.surface, borderRadius: 24, padding: 32, width: "100%", maxWidth: 380, border: `1px solid ${current.color}44`, boxShadow: `0 0 40px ${current.color}22` }}>
        <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 32 }}>
          {steps.map((_, i) => (
            <div key={i} style={{ width: i === step ? 24 : 8, height: 8, borderRadius: 4, transition: "all 0.3s", background: i === step ? current.color : "rgba(255,255,255,0.2)" }} />
          ))}
        </div>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 72, marginBottom: 20 }}>{current.emoji}</div>
          <div style={{ fontSize: 22, fontWeight: 900, color: C.text, marginBottom: 12 }}>{current.title}</div>
          <div style={{ fontSize: 15, color: C.muted, lineHeight: 1.7 }}>{current.desc}</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          {step > 0 && (
            <button onClick={() => setStep(s => s - 1)} style={{ flex: 1, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 14, padding: 14, color: C.muted, cursor: "pointer", fontWeight: 700, fontSize: 14, fontFamily: "inherit" }}>
              {lang === "en" ? "← Back" : "← Retour"}
            </button>
          )}
          <button
            onClick={() => isLast ? onClose?.() : setStep(s => s + 1)}
            style={{ flex: 2, background: current.color, border: "none", borderRadius: 14, padding: 14, color: current.color === "#9FE1CB" || current.color === "#EF9F27" ? "#1C1C1E" : "white", cursor: "pointer", fontWeight: 800, fontSize: 14, fontFamily: "inherit", boxShadow: `0 4px 20px ${current.color}55` }}
          >
            {isLast
              ? (lang === "en" ? "🚀 Let's go!" : "🚀 Commencer !")
              : (lang === "en" ? "Next →" : "Suivant →")}
          </button>
        </div>
        {!isLast && (
          <button onClick={onClose} style={{ width: "100%", background: "none", border: "none", color: C.muted, cursor: "pointer", fontSize: 12, marginTop: 16, padding: 8, fontFamily: "inherit" }}>
            {lang === "en" ? "Skip tutorial" : "Passer le tutoriel"}
          </button>
        )}
      </div>
    </div>
  );
}
